import { useState, useMemo } from 'react';
import { certificates } from '../data/certificates';
import { ui } from '../data/ui';
import { SEO } from '../components/ui/SEO';
import { SectionHeader } from '../components/ui/SectionHeader';
import { CertificateCard, CertificateModal, useCertificateModal } from '../components/ui/CertificateCard';
import { AchievementsBlock } from '../components/sections/AchievementsBlock';
import '../components/sections/AchievementsBlock.css';
import './CertificationsPage.css';

export function CertificationsPage() {
  const [search, setSearch] = useState('');
  const modal = useCertificateModal();

  const filtered = useMemo(() => {
    if (!search.trim()) return certificates;
    const q = search.toLowerCase();
    return certificates.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.issuer.toLowerCase().includes(q)
    );
  }, [search]);

  return (
    <>
      <SEO title={ui.seo.certifications} description={ui.sections.certificationsSub} />

      <div className="page-header">
        <div className="container">
          <SectionHeader
            label={ui.sections.credentials}
            title={ui.sections.certificationsTitle}
            subtitle={ui.sections.certificationsSub}
            align="center"
          />
        </div>
      </div>

      <section className="section">
        <div className="container">
          <AchievementsBlock />

          <div className="certificates-block">
            <h3 className="cert-subsection-title">{ui.certifications.certificatesTitle}</h3>

            <div className="cert-search">
              <input
                type="text"
                className="form-input"
                placeholder={ui.certifications.searchPlaceholder}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="certificates-grid">
              {filtered.map((cert, i) => (
                <CertificateCard
                  key={cert.id}
                  certificate={cert}
                  index={i}
                  onClick={modal.open}
                />
              ))}
            </div>

            {filtered.length === 0 && (
              <p className="cert-no-results">{ui.certifications.noResults}</p>
            )}
          </div>
        </div>
      </section>

      <CertificateModal certificate={modal.selected} onClose={modal.close} />
    </>
  );
}
